import type { CSSProperties } from "react";

import { useTranslation } from "react-i18next";

import { Checkbox, Divider, Message } from "semantic-ui-react";

import type { OpenAPI } from "simplydo/interfaces";
import { RichTextViewer } from "simplydo/react/richtext";

import util from "utils/utils";

type TermsCheckboxProps = {
  organisation: OpenAPI.Schemas["Organisation"];
  agreed: boolean;
  onAgree: (checked: boolean) => void;
  agreedCustomTerms: boolean;
  onAgreeCustomTerms: (checked: boolean) => void;
  style?: CSSProperties;
};

const TermsCheckbox = ({
  organisation,
  agreed,
  agreedCustomTerms,
  onAgree,
  onAgreeCustomTerms,
  style,
}: TermsCheckboxProps) => {
  const { t } = useTranslation();

  const customTerms = organisation?.customTerms;

  return (
    <div style={{ ...style }}>
      <p>
        {t("entry.terms.instruction", { appName: util.appName() })}{" "}
        <a
          href="https://simplydo.co.uk/terms-of-use"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("entry.terms.terms")}
        </a>{" "}
        {t("generic.and")}{" "}
        <a
          href="https://simplydo.co.uk/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("entry.terms.privacy")}
        </a>
        .
      </p>
      <div style={{ paddingLeft: 20, padding: 10 }}>
        <Checkbox
          size="large"
          checked={agreed}
          onChange={(_e, c) => onAgree(c.checked)}
          label={t("entry.terms.iAgree")}
        />
      </div>

      {customTerms?.enabled && customTerms?.terms && (
        <>
          <Divider />
          <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
            <h4>
              {t("entry.terms.additionTermsTitle", {
                orgName: organisation?.name,
              })}
            </h4>
          </div>
          <RichTextViewer value={customTerms?.terms} />
          <div style={{ paddingLeft: 20, padding: 10, marginTop: 10 }}>
            <Checkbox
              style={{ textAlign: "left" }}
              agreed={agreedCustomTerms}
              onChange={(_c, data) => {
                onAgreeCustomTerms(data.checked);
              }}
              label={t("entry.terms.iAgreeCustomTerms", {
                orgName: organisation?.name,
              })}
            />
          </div>
        </>
      )}
      <Message size="small">{t("entry.terms.info")}</Message>
    </div>
  );
};

export default TermsCheckbox;
